<template>
  <Box>
    <template #handle>
      <Btn @click="changeOpen" type="blue">新增初始化外部设备</Btn>
    </template>
    <template #content>
      <div class="table_main">
        <!-- <div class="query">
          <div class="left">
            <el-form ref="query_form" :model="queryParams" label-width="80px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="设备编号" prop="xbbh">
                    <el-input
                      size="small"
                      v-model="queryParams.xbbh"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="所在企业" prop="companyname">
                    <el-input
                      size="small"
                      v-model="queryParams.companyname"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="省市区" prop="qy">
                    <el-input size="small" v-model="queryParams.qy"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="生产线" prop="sccode">
                    <el-input size="small" v-model="queryParams.sccode"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="设备状态" prop="sbstate">
                    <el-input
                      size="small"
                      v-model="queryParams.sbstate"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="right">
            <Btn round>
              <span class="btn_box">
                <i class="iconfont icon-sousuo"></i>
                <span>搜索</span>
              </span>
            </Btn>
            <Btn round>
              <span class="btn_box">
                <i class="iconfont icon-chongzhi"></i>
                <span>重置</span>
              </span>
            </Btn>
          </div>
        </div> -->
        <div class="content">
          <Table :datas="tableData" :heads="tableHead" :selection="false">
            <template #handle="data">
              <div class="table_cell">
                <span v-if="data.head.handle == 'index'">{{
                    (pageData.page - 1) * 10 + data.index
                }}</span>
                <span v-if="data.head.handle == 'status'" :class="['pre']" @click="test(data)">
                  <span class="_pre" :style="{
                    background: (
                      sbstate.find((a) => a.value == data.data.sbstate) || {}
                    ).color,
                  }"></span>
                  <span>{{
                      (sbstate.find((a) => a.value == data.data.sbstate) || {}).label
                  }}</span>
                </span>
                <div v-if="data.head.handle == 'btns'">
                  <Btn type="text">修改</Btn>
                </div>
              </div>
            </template>
          </Table>
          <el-pagination class="page" background layout="prev, pager, next" :total="46">
          </el-pagination>
        </div>
      </div>
      <Drawer :open="open" @changeOpen="changeOpen">
        <template #content>
          <el-form :model="addForm" label-width="130px" class="demo-ruleForm formBox">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="名称：" prop="mc">
                  <el-input size="small" v-model="addForm.mc"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="型号：" prop="xh">
                  <el-input size="small" v-model="addForm.xh"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="品牌：" prop="mp">
                  <el-input size="small" v-model="addForm.mp"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="生产商：" prop="scs">
                  <el-input size="small" v-model="addForm.scs"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="生产地址：" prop="scdz">
                  <el-input size="small" v-model="addForm.scdz"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系人：" prop="lxr">
                  <el-input size="small" v-model="addForm.lxr"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="联系电话：" prop="lxdh">
                  <el-input size="small" v-model="addForm.lxdh"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="生产日期：" prop="scrq">
                  <el-input size="small" v-model="addForm.scrq"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="设备状态：" prop="sbstate">
                  <el-select v-model="addForm.sbstate" size="small">
                    <el-option v-for="item in sbstate" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="状态修改时间：" prop="ztxgsj">
                  <el-date-picker size="small" v-model="addForm.ztxgsj" type="date" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="状态修改原因：" prop="ztxgyy">
                  <el-input type="textarea" v-model="addForm.ztxgyy"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="修改时间：" prop="xgsj">
                  <el-date-picker size="small" v-model="addForm.xgsj" type="date" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="操作人：" prop="czr">
                  <el-input size="small" v-model="addForm.czr"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
        <template #footer>
          <Btn type="blue">提交</Btn>
          <Btn>取消</Btn>
        </template>
      </Drawer>
    </template>
  </Box>
</template>

<script>
import { sbstate } from "@/utils/status";
import drawerMixins from "@/components/drawer/drawer";
import { getOutDeviceList } from "@/api/DeviceManagement";
export default {
  mixins: [drawerMixins],
  data() {
    return {
      sbstate: sbstate,
      queryParams: {},
      tableData: [],
      tableHead: [
        {
          prop: "xh",
          label: "序号",
          handle: "index",
          width: 50,
          textAlign: "right",
        },
        {
          prop: "mc",
          label: "名称",
        },
        {
          prop: "xh",
          label: "型号",
        },
        {
          prop: "sbstate",
          label: "设备状态",
          handle: "status",
        },
        {
          prop: "mp",
          label: "名牌",
        },
        {
          prop: "scs",
          label: "生产商",
        },
        {
          prop: "scdz",
          label: "生产地址",
        },
        {
          prop: "lxr",
          label: "联系人",
        },
        {
          prop: "lxdh",
          label: "联系电话",
          minWidth: 110,
        },
        {
          prop: "scrq",
          label: "生产日期",
          minWidth: 100,
        },
        {
          prop: "cz",
          label: "操作",
          handle: "btns",
          fixed: "right",
        },
      ],
      addForm: {
        mc: "",
        xh: "",
        mp: "",
        scs: "",
        scdz: "",
        lxr: "",
        lxdh: "",
        scrq: "",
        sbstate: "",
        ztxgsj: "",
        ztxgyy: "",
        xgsj: "",
        czr: "",
      },
      pageData: {
        total: 0,
        page: 1,
      },
    };
  },
  methods: {
    test(data) { },
    getList() {
      const params = {
        currentPage: 1,
        // pageSize: 10,
      };
      getOutDeviceList(params).then((res) => {
        this.tableData = res.data.list
        pageData.total = res.data.count
      });
    },
    init() {
      this.getList();
    },
  },
  created() {
    this.init();
  },
};
</script>
